<template>
      <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                  <div class="nav-bar box-horizontal mb-0">
                    <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                    <div class="flex-1">
                      <h3 class="m-0">Tugas Admin</h3>
                      <p class="mb-0">Kumpulan tugas buat teknisi ya gan :)</p>
                    </div>
                  </div>
                  <div class="mt-3">
                    <router-link :to="{ name: 'tugas-tambah' }"  class="btn btn-primary">Tambah Tugas</router-link>
                    <router-link :to="{ name: 'tugas-total' }"  class="btn btn-primary">Total Teknisi Nugas</router-link>
                    <button @click="data.tanggalBox = true;"  class="btn btn-info" v-show="!data.tanggalBox">Filter Tanggal</button>
                    <button @click="
                      data.teknisiBox = true"
                      class="btn btn-info" v-show="!data.teknisiBox">Filter Teknisi</button>
                  </div>
                  <div class="card mt-3">
                    <div class="card-body">
                        <div class="row">
                          <div class="col-md-4" v-show="data.tanggalBox">
                            <label for="tanggal" class="text-dark">Pilih Tanggal</label>
                            <div class="box-horizontal">
                              <vuejs-datepicker :format="theGet.customFormatter" id="tanggal" type="text" placeholder="Pilih Tanggal..." v-model="data.tanggal" style="width: 100%"></vuejs-datepicker>
                            </div>
                          </div>

                          <div class="col-md-4" v-show="data.teknisiBox">
                            <label for="tanggal" class="text-dark">Teknisi</label>
                            <div class="box-horizontal">
                              <h3 class="text-info cursor-pointer m-0 mr-4" role="button" @click="data.modalTeknisi = true;
                              data.modalTeknisiState = 'filter'"  v-text="data.teknisiNama === null ? 'Filter Teknisi ': data.teknisiNama">Pilih Teknisi</h3>
                            </div>
                          </div>
                          <div v-show="data.teknisiBox|| data.tanggalBox">
                              <button class="btn btn-info btn-sm" type="button" style="height: 30px;" @click="theGet.datae()">Cari</button>
                          </div>
                        </div>

                        <div class="table-responsive">
                        <table class="table">
                            <thead class=" text-info">
                            <th>Tugas</th>
                            <th>Pelanggan</th>
                            <th>Job</th>
                            <th>Teknisi</th>
                            <th>Status</th>
                            <th>Kerusakan</th>
                            </thead>
                            <!-- LOADING -->
                            <tbody v-show="data.loading">
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            <tr>
                                <td colspan="8"><Loading></Loading></td>
                            </tr>
                            </tbody>
                            <!-- DATA -->
                            <tbody v-show="!data.loading">
                            <tr v-for="(u, index) in theGet.data.List">
                                <td>
                                  <strong class="d-block text-info p-1">Tugas #{{ u.fake_id }}</strong>
                                  <span class="d-block">{{myGlobal.tglIndo(u.tanggal)}}</span>
                                  <button class="btn btn-sm btn-info" @click="data.modalDetail = true,data.modalData = u,theGet.detail(u.id)">Rincian</button>
                                </td>
                                <td>
                                    <span class="d-block">{{ u.unama }}</span>
                                    <span class="d-block text-secondary">{{ u.wa }}</span>
                                    <span class="d-block text-secondary">{{ u.anama }}</span>
                                </td>
                                <td>
                                  {{u.teks}}
                                </td>
                                <td>
                                  {{u.proses_oleh}}
                                </td>
                                <td>
                                    <div v-if="u.status == 'pending'">
                                      <span class="d-block text-warning">Pending</span>
                                      <span class="d-block text-gray">{{u.jam}} - {{ myGlobal.tglIndo(u.tanggal) }}</span>
                                    </div>
                                    <div v-else-if="u.status == 'proses'">
                                      <span class="d-block text-info">Proses</span>
                                      <span class="d-block text-gray">{{u.jam_proses}} - {{ myGlobal.tglIndo(u.tgl_proses) }}</span>
                                    </div>
                                    <div v-else-if="u.status == 'done'">
                                      <span class="d-block text-success">Selesai</span>
                                      <span class="d-block text-gray">{{u.jam_selesai}} - {{ myGlobal.tglIndo(u.tgl_selesai) }}</span>
                                    </div>
                                </td>
                                <td>
                                  {{u.kerusakan}}
                                </td>
                            </tr>
                            <!-- NULL -->
                            <tr v-if="theGet.data.List == null">
                                <td></td>
                                <td>Tidak ada Data </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
                </div>
                
            </div>
        </div>

        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalDetail">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document" v-if="data.modalData != null">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Detail Tugas <span class="text-info">#{{data.modalData.fake_id}}</span></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalDetail = false">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="height: 500px; overflow: auto">
                    <div class="row">
                      <div class="col-md-12">
                        <label for="" class="text-secondary">Tugas</label>
                        <p class="text-info">{{data.modalData.teks}}</p>
                      </div>
                      <div class="col-md-12">
                        <div class="d-flex">
                            <div class="flex-1">
                                <label for="" class="text-secondary">Teknisi</label>
                                <p v-html="data.detailTeknisi"></p>
                            </div>
                            <div>
                                <button class="btn btn-sm btn-info" @click="data.modalTeknisi = true">+ Teknisi</button>
                            </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary d-block">Status</label>
                        <p class="text-warning" v-if="data.modalData.status == 'pending'">Pending</p>
                        <p class="text-info" v-else-if="data.modalData.status == 'proses'">Proses</p>
                        <p class="text-success" v-else>Done</p>
                      </div>
                      <div class="col-md-12" v-if="data.modalData.ur_id != null">
                        <label for="" class="text-secondary d-block">Pelanggan</label>
                        <p>{{data.detailPel}} - {{data.detailPelWA}} - {{data.detailPelArea}}</p>
                      </div>
                      <div class="col-md-12 mb-3">
                        <label for="" class="text-secondary d-block">Jam & Tanggal</label>
                        <div class="d-block">
                            <div class="d-flex">
                                <span class="text-warning">Pending : </span>&nbsp;
                                <span class="text-warning">{{data.modalData.jam}} - {{myGlobal.tglIndo(data.modalData.tanggal)}}</span>
                            </div>
                            <div class="d-flex">
                                <span class="text-info">Proses : </span>&nbsp;
                                <span class="text-info">{{data.modalData.jam_proses}} - {{myGlobal.tglIndo(data.modalData.tgl_proses)}}</span>
                            </div>
                            <div class="d-flex">
                                <span class="text-success">Proses : </span>&nbsp;
                                <span class="text-success">{{data.modalData.jam_selesai}} - {{myGlobal.tglIndo(data.modalData.tgl_selesai)}}</span>
                            </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary d-block">Kerusakan</label>
                        <p class="text-danger">{{data.modalData.kerusakan}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="data.modalDetail = false">Okelah</button>
                  </div>
              </div>
          </div>
        </div>

        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalTeknisi">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document" >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Pilih Teknisi</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalTeknisi = false">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="height: 500px; overflow: auto">
                    <div class="table-responsive">
                      <table class="table">
                          <thead class=" text-info">
                          <th width="40px">No.</th>
                          <th>Nama</th>
                          <th>Aksi</th>
                          </thead>
                          <tbody>
                            <tr v-for="(u, index) in theGet.data.Teknisi">
                                <td>{{ index+1 }}</td>
                                <td>{{ u.nama }}</td>
                                <td>
                                    <button class="btn btn-sm btn-info" @click="data.modalTeknisi = false,theGet.UpdateTugas(u.id,u.nama)"><i class="material-icons">check</i></button>
                                </td>
                            </tr>
                            <!-- NULL -->
                            <tr v-if="theGet.data.Teknisi == null">
                                <td></td>
                                <td>Tidak ada Data </td>
                            </tr>
                          </tbody>
                      </table>
                    </div>
                  </div>
              </div>
          </div>
          
        </div>

      </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 
import vuejsDatepicker from 'vuejs-datepicker'

export default {
  name: 'Beranda',
	components: { 
    vuejsDatepicker,
    "Loading" : Loading
	}, 
  setup() {
    const data = reactive({
      loading: true,
      // modal detail
      modalDetail: false,
      // rincian detail teknisi & pelanggan
      modalData: null,
      modalTeknisi: false,
      modalTeknisiState: null,  // null / filter
      detailTeknisi: null,
      detailPel: null,
      detailPelWA: null,
      detailPelArea: null,
      tanggal: null,
      tanggalBox: false,
      teknisiBox: false,
      teknisiID: null,
      teknisiNama: null
    })

    const theGet = {
      customFormatter(date) {
        return moment(date).format('YYYY-MM-DD');
      },
      data: reactive({
        List: [],
        Teknisi: [],
        Total: "0",
      }),
      dataeNow() {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          from: "web"
        };

        if(data.tanggal != null) {
          datax["tanggal"] = this.customFormatter(data.tanggal)
        }

        if(data.teknisiID != null) {
          datax["teknisi"] = data.teknisiID
        }

        //console.log(JSON.stringify(datax))
    
        var apiUrl = inter.TugasList();
        myGlobal.call(datax,apiUrl).then(x => {
          
            //myGlobal.loger(x);

            data.loading = false;

            if (x.status == true) {
              this.data.List = x.data;
              this.data.Total = x.pesan.masuk;
            } else {
              theGet.data.List = null;
            }
        })
      },
      datae() {
        data.loading = true;
        setTimeout(function() {
          theGet.dataeNow();
        }, 1000);
      },
      detail(id) {
        data.modalTeknisiState = null;

          var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken'),
              id: id
          };
      
          var apiUrl = inter.TugasDetail();
          myGlobal.call(datax,apiUrl).then(x => {

              //myGlobal.loger(x);

              if (x.status == true) {

                // console.log(x.data.teknisi);

                data.detailTeknisi = x.data.teknisi.replace(/\n/g, "<br />");
                data.detailPel = x.data.unama;
                data.detailPelWA = x.data.uwa;
                data.detailPelArea = x.data.area;
              
              } else {
              theGet.data.List = null;
              }
          })
      },
      getTeknisi() {
          var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken')
          };
      
          var apiUrl = inter.TeknisiList();
          myGlobal.call(datax,apiUrl).then(x => {
            // console.log(JSON.stringify(x))

            if (x.status == true) {

              this.data.Teknisi = x.data;
            
            } else {
            theGet.data.List = null;
            }
          })
      },
      UpdateTugas(teknisi,nama) {
        //console.log("modalteknisistate "+data.modalTeknisiState)

        
        if(data.modalTeknisiState == "filter") {
          // filter

          data.teknisiID = teknisi;
          data.teknisiNama = nama;
        } else {
          var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken'),
              id: data.modalData.id,
              teknisi: teknisi,
          };
      
          var apiUrl = inter.TugasUpdateTeknisi();
          myGlobal.call(datax,apiUrl).then(x => {

              if (x.status == true) {
                
                this.detail(data.modalData.id);
              
              } else {
                

              }
          })
        }

      }
    }
    return {
      data,
      myGlobal,
      theGet
    }
  },
  mounted () {
    document.title = "Tugas";

    this.data.namaQ = sessionStorage.getItem('admin');
    this.theGet.datae();
    this.theGet.getTeknisi();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.cursor-pointer{
  cursor: pointer;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/tugas/main.vue